import React from "react";
import useTimerShow from "../../../hook/useTimerShow";
import { useStyleDisplay } from "../helpers/useStyleDisplay";

export default function CashierDisplayDateTime() {
    const DateTime = useTimerShow();
    const classsDisplay = useStyleDisplay();
    return (
        <div>
            <h3
                className={`t-text-primary mb-0 text-center text-xl-left ${classsDisplay.headTextTime}`}>{`${DateTime.days}/${DateTime.months}/${DateTime.years} ${DateTime.hours}:${DateTime.minutes}:${DateTime.seconds}`}</h3>
        </div>
    );
}
